import request from "@/utils/axios";

const initDictionary = async () => {
  try {
    let obj = {};
    let data = await request({
      url: "/edu_basic/auth/get_dictionary_all_list",
      method: "get",
    });

    data.forEach((item) => {
      let { type, dicList } = item;
      obj[type] = dicList.map((i) => {
        let { code: value, value: label, selected } = i;
        return { label, value, selected };
      });
    });
    return obj;
  } catch (err) {
    console.error("初始化字典失败", err);
  }
};

export default initDictionary;
